class ReportContent
{

    constructor()
    {
        this.type = null;
    }

    report(sender)
    {
        this.type = sender.dataset.type;
        this.id = sender.dataset.content_id;
        this._getModal();
    }

    submitReport(form)
    {
        app.form.post(form, '/services/report-content/report', this._reportSubmitted.bind(this));
    }

    _getModal()
    {
        app.ajax.get('/services/report-content/modal', {'type': this.type, 'id': this.id}, this._showModal.bind(this));
    }

    _showModal(response)
    {
        app.modal.open('', response.body, '');
    }

    _reportSubmitted(response)
    {
        app.modal.close();
        app.alert.success(response.header, response.message);
    }

}